//todo rename this file now that navigation is moved out????

// For Popovers
(function waitForBootstrap() {
  if (typeof window.bootstrap !== 'undefined' && typeof window.bootstrap.Popover === 'function') {
    var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
    var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
      return new bootstrap.Popover(popoverTriggerEl)
    })
  } else {
    setTimeout(waitForBootstrap, 50)
  }
})();
